import UserCreate from "../components/userCreate";
import UserEditView from "../components/userEditView";
import UserList from "../components/userList";
import ResetUserPassword from "../components/resetUserPassword";
import { Navigate } from "react-router-dom";
import SvgIcons from "../../../../shared/components/svgIcons";

const userRoute = {
  icon: SvgIcons.UsersIcon,
  name: "Users and Controls",
  link: "/users-controls",
  path: "/user-controls",
  element: "",
  index: 990,
  children: [
    {
      path: "users",
      element: <UserList />,
      permission: "User",
      name: "Users",
      index: 1,
      link: "user-controls/users",
      icon: SvgIcons.UsersIcon,
    },
    {
      path: "users/create",
      element: <UserCreate />,
    },
    {
      path: "users/:id",
      element: <UserEditView />,
    },
    {
      path: "users/reset-user-password/:id",
      element: <ResetUserPassword />,
    },
    {
      path: "",
      element: <Navigate to="user-controls/users" replace />,
    },
  ],
};
export default userRoute;
